module.exports = __webpack_public_path__ + "assets/images/project/fireworks-2.gif?v=46d2293e";